import React, { useContext, useState, useEffect } from "react";
import { DashboardContext } from '../../context/DashboardContext'
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, Legend, Category, StackingBarSeries, DataLabel, Highlight, Tooltip } from '@syncfusion/ej2-react-charts';
import { InputLabel, MenuItem, FormControl, Select, Skeleton } from '@mui/material'
import { FaStar, FaRegStar } from "react-icons/fa";

export default function BscXSwotXGutXDemanda({ corFavorito, cicloDemandaKey, swotKey, tab }) {
    const { qtdGutXBscXSwotXDemanda, setGutXBscXSwotXDemanda, getBscXSwotXGutXDemanda, BscXSwotXGutXDemanda, AdicionarGraficoFavorito } = useContext(DashboardContext)
    const [isLoading, setIsLoading] = useState(false)
    const theme = localStorage.getItem('theme') || 'light'

    useEffect(() => {
        if (cicloDemandaKey != "" && swotKey != "") {
            setIsLoading(true)
            getBscXSwotXGutXDemanda(cicloDemandaKey, swotKey, qtdGutXBscXSwotXDemanda)
                .then(() => {
                    setIsLoading(false)
                })
        }
    }, [cicloDemandaKey, swotKey, qtdGutXBscXSwotXDemanda])

    const onChartLoad = (args) => {
        let chart = document.getElementById(`${tab}-gutxbscxswotxdemanda`);
        chart.setAttribute('title', '');
    };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between', padding: '0' }}>
                <h2 className="h2-bsc">
                    <button onClick={() => AdicionarGraficoFavorito("BSC")} className='btn-grafico'>{corFavorito("BSC") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                    <span style={{ fontWeight: '500' }}>BSC + SWOT + GUT</span>
                </h2>
                <FormControl size="small" sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="qtd-demanda-3">Quantidade de demandas</InputLabel>
                    <Select
                        className='span-bsc'
                        labelId="qtd-demanda-label-3"
                        id="qtd-demanda-3"
                        value={qtdGutXBscXSwotXDemanda}
                        label="Quantidade de demandas"
                        onChange={(e) => setGutXBscXSwotXDemanda(parseInt(e.target.value))}
                    >
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="10">10</MenuItem>
                        <MenuItem value="15">15</MenuItem>
                        <MenuItem value="20">20</MenuItem>
                        <MenuItem value="30">30</MenuItem>
                        <MenuItem value="40">40</MenuItem>
                        <MenuItem value="1000">Todas</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div className="modal-content">
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '500px' }}>
                    {isLoading ?
                        <Skeleton variant="rounded" width="100%" height={550} />
                        :
                        <ChartComponent id={`${tab}-gutxbscxswotxdemanda`} style={{ textAlign: "center" }} legendSettings={{ enableHighlight: true }}
                            primaryXAxis={
                                {
                                    valueType: 'Category',
                                    majorGridLines: { width: 0 },
                                    majorTickLines: { width: 0 },
                                    titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' },
                                }
                            }
                            primaryYAxis={
                                {
                                    edgeLabelPlacement: 'Shift',
                                    majorTickLines: { width: 0 },
                                    lineStyle: { width: 0 },
                                    visible: false,
                                    titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' },
                                }
                            }
                            axisLabelRender={(args) => {
                                theme == 'light' ? args.labelStyle.color = '#fff' : args.labelStyle.color = '#3f3f46'
                                if (args.axis.name === 'primaryXAxis' && args.text.length > 30) {
                                    args.text = args.text.substring(0, 30) + "...";
                                }
                            }}
                            chartArea={{ border: { width: 0 } }}
                            loaded={onChartLoad.bind(this)}
                            tooltip={{ enable: true, format: '${point.x} : <b>${point.y}</b>' }}
                            width="1300"
                        >
                            <Inject services={[StackingBarSeries, Legend, Tooltip, DataLabel, Category, Highlight]} />
                            <SeriesCollectionDirective>
                                <SeriesDirective dataSource={BscXSwotXGutXDemanda} xName='x' yName='y' name='GUT' border={{ width: 1, color: "white" }} columnWidth={0.6} type='StackingBar100' />
                                <SeriesDirective dataSource={BscXSwotXGutXDemanda} xName='x' yName='y1' name='BSC' border={{ width: 1, color: "white" }} columnWidth={0.6} type='StackingBar100' />
                                <SeriesDirective dataSource={BscXSwotXGutXDemanda} xName='x' yName='y2' name='SWOT' border={{ width: 1, color: "white" }} columnWidth={0.6} type='StackingBar100' />
                            </SeriesCollectionDirective>
                        </ChartComponent>
                    }
                </div>
            </div>
        </>
    )
}